module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-runtime/core-js/object/assign.js
// module id = 1552
// module chunks = 0 1 2 3 4 5 6 7 8 10 11 13 17 18 19 20 21